/** Gives the iframe inside `container` an accessible name; no-op if none is rendered (yet). */
export function setIframeTitle(container: ParentNode | null | undefined, title: string): void {
    container?.querySelector('iframe')?.setAttribute('title', title);
}
